module.exports = __webpack_public_path__ + "client/styles/fonts/Roboto-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/styles/fonts/Roboto-Regular.ttf
// module id = 1479
// module chunks = 0